<template>
    <div class="notifications">
        <transition-group name="list"
                          tag="ul">
            <notification
                class="list-item"
                v-for="notification in notifications"
                :key="notification.id"
                v-bind="notification"
                :clickHandler="notification.onClick"
                @close="removeNotification(notification.id)"
            >
            </notification>
        </transition-group>
    </div>
</template>

<script setup lang="ts">
import { useNotificationStore } from '@/stores/notifications';
import { storeToRefs } from 'pinia';

// Импортируем store уведомлений
const notificationStore = useNotificationStore();

// Получаем список уведомлений из стора
const { notifications } = storeToRefs(notificationStore);

// Удаляем уведомление
const removeNotification = (id: string) => {
    notificationStore.removeNotification(id);
};
</script>

<style lang="scss">
.notifications {
    position: fixed;
    z-index: 10000;
    top: 20px;
    right: 20px;
    width: min(480px, calc(100vw - 40px));

    ul {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        align-items: flex-end;
        width: 100%;
        padding: 0;
        margin: 0;
    }

    .list-enter-active,
    .list-leave-active {
        transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
    }

    /* Вход и выход элементов */
    .list-enter-from,
    .list-leave-to {
        opacity: 0;
        transform: translateX(-30px);
    }

    .list-enter-to,
    .list-leave-from {
        opacity: 1;
        transform: translateX(0);
    }

    .list-leave-active {
        position: absolute;
    }

    .list-item {
        list-style: none;
        width: 100%;
        cursor: pointer;
        opacity: 1;
        transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
        margin-bottom: 0;
    }
}
</style>
